import React from "react";

import { Message, Type } from "@/mk2/apps/bazaar/components/Message";
import { BazaarMessageEntity } from "@/mk2/apps/bazaar/schemas";
import { Emojify } from "@/mk2/components/Emojify";
import { linebreaksbr, urlize } from "@/mk/bazaar/common/filters";

interface OwnProps {
    className?: string;
    message: BazaarMessageEntity;
    type: Type;
    showProduct?: boolean;
}

type Props = OwnProps;

export const UserMessage: React.FunctionComponent<Props> = React.memo(
    ({ className, message, type, showProduct = false }) => {
        const author = message.isSeller
            ? message.buyer?.product?.seller?.user || message.seller
            : message.buyer.user;

        return (
            <Message
                className={className}
                author={author}
                sentDate={message.sentDate}
                message={<Emojify>{urlize(linebreaksbr(message.message), 50)}</Emojify>}
                messageType={message.messageType}
                type={type}
                product={message.buyer?.product}
                showProduct={showProduct}
                photos={message.messagePhotos?.map((p) => p.photofile) || message.photos}
                isNew={message.isNew}
            />
        );
    },
);

UserMessage.displayName = "UserMessage";
